import Loadable from 'components/Loadable';
import AuthLayout from '../layouts/AuthLayout';
import LeadWrapper from 'pages/leads/LeadWrapper';
import ObjectWrapper from 'pages/objects/ObjectWrapper';
import WarehouseWrapper from 'pages/warehouse/WarehouseWrapper';
import ClientWrapper from 'pages/clients/ClientWrapper';


const DashboardPage = Loadable(()=>import('pages/dashboard/DashboardPage'));
const UsersPage = Loadable(()=>import('pages/users/UsersPage'));
const IndexPage = Loadable(()=>import('pages/index/IndexPage'));
const ProfilePage = Loadable(()=>import('pages/profile/ProfilePage'));
const SourceLeadsPage = Loadable(()=>import('pages/settings/SourceLeadsPage'));
const ApiKeysPage = Loadable(()=>import('pages/settings/ApiKeysPage'));
const ApiDocsPage = Loadable(()=>import('pages/settings/ApiDocsPage'));
const BusinessModePage = Loadable(()=>import('pages/settings/BusinessModePage'));
const MainSettingsPage = Loadable(()=>import('pages/settings/MainSettingsPage'));
const TelegramBotPage = Loadable(()=>import('pages/settings/TelegramBotPage'));
const ProposalPage = Loadable(()=>import('pages/proposal/ProposalPage'));
const DocumentsPage = Loadable(()=>import('pages/documents/DocumentsPage'));
const TariffPage = Loadable(()=>import('pages/tariff/TariffPage'));
const WarehousePage = Loadable(()=>import('pages/warehouse/WarehousePage'));
const SupplierRequestsPage = Loadable(()=>import('pages/warehouse/SupplierRequestsPage'));
const LeadsPage = Loadable(()=>import('pages/leads/LeadsPage'));
const ClientsPage = Loadable(()=>import('pages/clients/ClientsPage'));
const CustomersListPage = Loadable(()=>import('pages/clients/CustomersListPage'));
const LeadCardPage = Loadable(()=>import('pages/leads/LeadCardPage'));
const ObjectsPage = Loadable(()=>import('pages/objects/ObjectsPage'));
const ObjectCardPage = Loadable(()=>import('pages/objects/ObjectCardPage'));
const SalesPage = Loadable(()=>import('pages/sales/SalesPage'));
const SalesWrapper = Loadable(()=>import('pages/sales/SalesWrapper'));
const SaleCardPage = Loadable(()=>import('pages/sales/SaleCardPage'));
const ServiceSalesPage = Loadable(()=>import('pages/service-sales/ServiceSalesPage'));
const ServiceSalesWrapper = Loadable(()=>import('pages/service-sales/ServiceSalesWrapper'));
const ServiceSaleCardPage = Loadable(()=>import('pages/service-sales/ServiceSaleCardPage'));
const ProductsPage = Loadable(()=>import('pages/products/ProductsPage'));
const SetsPage = Loadable(()=>import('pages/sets/SetsPage'));
const ServicesPage = Loadable(()=>import('pages/services/ServicesPage'));

const ObjectsPage4Team = Loadable(()=>import('pages/4team/Objects'));
const WarehousePage4Team = Loadable(()=>import('pages/4team/Warehouse'));

const ReportObjectsPage = Loadable(()=>import('pages/reports/ReportObjectsPage'));
const ReportTeamsPage = Loadable(()=>import('pages/reports/ReportTeamsPage'));
const ReportUsersPage = Loadable(()=>import('pages/reports/ReportUsersPage'));
const TasksPage = Loadable(()=>import('pages/tasks/TasksPage'));
const ToolsBasePage = Loadable(()=>import('pages/tools/ToolsBasePage'));
const MyToolsPage = Loadable(()=>import('pages/tools/MyToolsPage'));

    
const MainRoutes = {
    path: '/',
    element: <AuthLayout/>,  
    children: [
        
        {
            // Головна сторінка
            path: '/',
            element: <IndexPage/>
        },

        {
            // Користуваччы
            path: '/users',
            element: <UsersPage/>
        }, 

        {   
            // Дашбоард
            path: '/dashboard',
            element: <DashboardPage/>
        },

        {
            // Задачі
            path: '/tasks',
            element: <TasksPage/>
        },
 
        {
            path: '/settings',
            element: <MainSettingsPage/>
        },
        {
            path: '/settings/source-leads',
            element: <SourceLeadsPage/>
        },
        {
            path: '/settings/api-keys',
            element: <ApiKeysPage/>
        },
        {
            path: '/settings/api-docs',
            element: <ApiDocsPage/>
        },
        {
            path: '/settings/business-mode',
            element: <BusinessModePage/>
        },
        {
            path: '/settings/telegram-bot',
            element: <TelegramBotPage/>
        },
        {
            path: '/proposal',
            element: <ProposalPage/>
        },
        {
            path: '/documents',
            element: <DocumentsPage/>
        },
        {
            path: '/tariff',
            element: <TariffPage/>
        },

        {
            // Профыль користувача
            path: '/profile',
            element: <ProfilePage/>
        },   
 
        {   
            // Каталог товарів
            path: '/products',
            element: <ProductsPage/>
        },

        {
            path: '/sets',
            element: <SetsPage/>
        },

        {
            // Каталог послуг
            path: '/services',
            element: <ServicesPage/>
        },

        {
            // Склади з загальної обгорткою
            path: '/warehouse',
            element : <WarehouseWrapper/>, 
            children:[
                {
                    path: 'supplier-requests',
                    element: <SupplierRequestsPage/>
                },
                {
                    path: ':wId',
                    element: <WarehousePage/> 
                }
            ]
        },

        {
            // Список клієнтів
            path: '/clients',
            element : <ClientWrapper/>,
            children:[
                {
                    path: '',
                    element: <ClientsPage/>
                }
            ]
        },

        {
            // База суб’єктів
            path: '/customers',
            element: <CustomersListPage/>
        },

        {
            // Список заявок та заявка з загальною обгорткою
            path: '/leads',
            element : <LeadWrapper/>, 
            children:[
                {
                    path: '',
                    element: <LeadsPage/>
                },
                {
                    path: ':leadId',
                    element: <LeadCardPage/>
                }
                 
            ]
        },

        {
            // Список заявок та заявка з загальною обгорткою
            path: '/objects',
            element : <ObjectWrapper/>,  
            children:[
                {
                    path: '',
                    element: <ObjectsPage/>
                },
                {
                    path: ':objectId',
                    element: <ObjectCardPage/>
                }
                 
            ]
        },

        {
            path: '/sales',
            element: <SalesWrapper/>,
            children: [
                {
                    path: '',
                    element: <SalesPage/>
                },
                {
                    path: ':objectId',
                    element: <SaleCardPage/>
                }
            ]
        },

        {
            path: '/service-sales',
            element: <ServiceSalesWrapper/>,
            children: [
                {
                    path: '',
                    element: <ServiceSalesPage/>
                },
                {
                    path: ':objectId',
                    element: <ServiceSaleCardPage/>
                }
            ]
        },

        {
            path: '/tools',
            children:[
                {
                    path: '',
                    element: <ToolsBasePage/>
                },
                {
                    path: 'my',
                    element: <MyToolsPage/>
                }
            ]
        },

        {
            // Маршурти дла авторизованої бригади
            path: '/4team',
            element : <WarehouseWrapper/>, 
            children:[
                {
                    path: 'objects',
                    element: <ObjectsPage4Team/>
                },

                {       
                path: 'warehouse',
                    element: <WarehousePage4Team/>
                }
            ]
        },

        {
            // Маршурти дла авторизованої бригади
            path: '/reports',
            children:[
                {
                    path: 'objects',
                    element: <ReportObjectsPage/>
                },
                
                {       
                path: 'teams',
                    element: <ReportTeamsPage/>
                },
                {
                    path: 'users',
                    element: <ReportUsersPage/>
                }
            ]
        },

    ] 
}

export default MainRoutes;